import React from "react";
import { Link } from "react-router-dom";
import flowerLogo from "../../assets/gymea-flower-only.png";

interface DocumentEmptyStateProps {
  /** True when the empty list is the result of a filter/search, not a new user. */
  filtered?: boolean;
  onClearFilters?: () => void;
}

export const DocumentEmptyState: React.FC<DocumentEmptyStateProps> = ({
  filtered = false,
  onClearFilters,
}) => {
  if (filtered) {
    return (
      <div className="document-empty-state">
        <img
          src={flowerLogo}
          alt=""
          className="document-empty-state__image"
          aria-hidden="true"
        />
        <h2 className="document-empty-state__title">No matching documents</h2>
        <p className="document-empty-state__text">
          Try a different search or filter.
        </p>
        {onClearFilters && (
          <button
            type="button"
            className="document-empty-state__cta"
            onClick={onClearFilters}
          >
            Clear filters
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="document-empty-state">
      <img
        src={flowerLogo}
        alt=""
        className="document-empty-state__image"
        aria-hidden="true"
      />
      <h2 className="document-empty-state__title">No documents yet</h2>
      <p className="document-empty-state__text">
        Documents you generate are saved here automatically.
      </p>
      <Link to="/dashboard" className="document-empty-state__cta">
        Generate your first document
      </Link>
    </div>
  );
};
